import { Mods, mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import { InfoIconGray } from 'modules/sprites';
import styled from 'styled-components';

export const StyledInfoIconGray = styled(InfoIconGray)<StyledMods<Mods<'disabled'>>>`
    ${mods.disabled.true`
        opacity: 0.4;
        cursor: default;
    `}
`;
